var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"root"},[_c('mx-element',{ref:"nav",attrs:{"type":"Nav","theme":_vm.Theme}}),_c('div',{staticClass:"box panel3"},[_c('div',{staticClass:"flex-row bold"},[_vm._v(" 实时概况 ")]),_c('mx-page',{attrs:{"type":"Home","config":_vm.PageConfig,"name":_vm.config.Title + '顶部统计',"theme":"Panel"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }